// ---------------------------------------------------------------
// Customer records (admin intake). Each customer gets a 4-digit account number
// used to name their devices (account#-last4IMEI). Stored locally for now;
// moves into the accounts backend when that's built. membershipStart fills in
// when the customer activates their account (a device is claimed).
// ---------------------------------------------------------------

const KEY = 'dd-customers';
const get = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const save = (a) => localStorage.setItem(KEY, JSON.stringify(a));

export const PAYMENT_METHODS = ['Credit / Debit card', 'Bank / ACH', 'PayPal', 'Zelle', 'Cash', 'Other'];

// Membership tiers for TagAlong. "track" = buy device + yearly fee (tracking &
// in-app alerts). "talk" = buy device + monthly membership (two-way texting &
// calls with the car). "none" = lead / not subscribed yet.
export const PLANS = [
  { id: 'none', label: 'Not subscribed', billing: '', talk: false },
  { id: 'track', label: 'Track — yearly', billing: 'year', talk: false },
  { id: 'talk', label: 'Talk — monthly', billing: 'month', talk: true },
];
export const planById = (id) => PLANS.find((p) => p.id === id) || PLANS[0];
// does this customer's plan include two-way text/call with the car?
export const canTalk = (c) => planById(c && c.plan).talk;

export const getCustomers = () => get().sort((a, b) => (a.name || '').localeCompare(b.name || ''));
export const getCustomer = (id) => get().find((c) => c.id === id);

export function genAccountNumber() {
  const taken = new Set(get().map((c) => c.account));
  let n;
  do { n = String(Math.floor(1000 + Math.random() * 9000)); } while (taken.has(n));
  return n;
}

// A full customer record ("personal profile"). New records get every field so
// both the admin CRM and the customer's own profile can read/write consistently.
export const blankCustomer = () => ({
  name: '', company: '', phone: '', altPhone: '', email: '', altEmail: '',
  address: '', city: '', state: '', zip: '',
  emergencyName: '', emergencyPhone: '', // useful for a teen-driver product
  photo: '', // profile picture (data URL)
  lang: 'en', // preferred language
  payment: PAYMENT_METHODS[0], paymentNote: '', cardLast4: '', autopay: false, nextDue: '',
  membershipStart: null, notes: '',
  services: { tagalong: false, dispatch: false },
  status: 'Interested', // Interested (lead) | Customer (active)
  plan: 'none', // none | track (yearly) | talk (monthly, two-way text/call)
});

export function addCustomer(c) {
  const a = get();
  const rec = { id: `C${Date.now()}`, account: genAccountNumber(), createdAt: new Date().toISOString(), ...blankCustomer(), ...c };
  a.push(rec); save(a); return rec;
}
export function updateCustomer(id, patch) { save(get().map((c) => (c.id === id ? { ...c, ...patch } : c))); }
export function removeCustomer(id) { save(get().filter((c) => c.id !== id)); }

// mark membership start the first time a customer activates (device claimed)
export function markActivated(id) {
  const a = get(); const c = a.find((x) => x.id === id);
  if (c && !c.membershipStart) { c.membershipStart = new Date().toISOString(); save(a); }
}
